import { PlatoLogoSeasonal } from '../../../assets/icons/plato-logo-seasonal.tsx';
import { PlatoLogoWithTextSeasonal } from '../../../assets/icons/plato-logo-with-text-seasonal.tsx';
import { PlatoLogoWithText } from '../../../assets/icons/plato-logo-with-text.tsx';
import { PlatoLogo } from '../../../assets/icons/plato-logo.tsx';
import { useAppConfig } from '../../acl/acl-provider.tsx';

type Props = {
    className?: string;
};

/**
 * Main-nav Plato mark — renders the seasonal variant when the `enableSeasonalLogo`
 * feature flag is on, otherwise the default logo. The flag check lives here (inside
 * the AclProvider) so the leaf logo components stay pure and usable outside the
 * provider (e.g. the super-admin layout).
 */
export const NavLogo = ({ className = '' }: Props) => {
    const { enableSeasonalLogo } = useAppConfig();
    return enableSeasonalLogo ? (
        <PlatoLogoSeasonal className={className} />
    ) : (
        <PlatoLogo className={className} />
    );
};

export const NavLogoWithText = ({ className = '' }: Props) => {
    const { enableSeasonalLogo } = useAppConfig();
    return enableSeasonalLogo ? (
        <PlatoLogoWithTextSeasonal className={className} />
    ) : (
        <PlatoLogoWithText className={className} />
    );
};
